import {SideNavDefaults, SideNavUiConfig} from '@edifecs/fp-ui-lib';
import {AppConstants} from '@app/AppConstants';
import {AppConfigService} from './AppConfigService';
import {Injectable, Provider} from '@angular/core';

/**
 * Default settings for side nav component appearance.
 */
@Injectable({providedIn: 'root'})
export class SideNavDefaultsService extends SideNavDefaults {
    /**
     * Provider for base class.
     */
    public static readonly BASE_PROVIDER: Provider = {provide: SideNavDefaults, useExisting: SideNavDefaultsService};

    /**
     * Constructor
     * @param appConfig App config
     */
    constructor(private readonly appConfig: AppConfigService) {
        super();
    }

    /**
     * Side nav appearance
     */
    get uiConfig(): SideNavUiConfig | undefined {
        return {
            wideNav: AppConstants.CMFA_MODE
        };
    }

}
